<template>
  <div class="dynamic-words">
    <span class="label">插入动态名称:</span>
    <ul class="words-list">
      <li v-for="(word, i) in words" :key="i">
        <el-button type="text" @click="appendWord(word)">+{{ word }}</el-button>
      </li>
    </ul>
  </div>
</template>
<script>
export default {
  props: {
    words: Array
  },
  methods: {
    appendWord(word) {
      this.$emit('append', word)
    }
  }
}
</script>
<style lang="scss" scoped>
.dynamic-words {
  display: flex;
  align-items: center;
  .label {
    font-size: 12px;
  }
  li {
    display: inline-block;
    margin-left: 10px;
  }
}
</style>
